import { isDevFeatureEnvironment, isImageToolsEnabled as isImageToolsFeatureEnabled, isMediaToolsEnabled as isMediaToolsFeatureEnabled } from "./featureFlags";

export function isLocalMediaToolsEnvironment() {
	return isDevFeatureEnvironment();
}

export function isMediaToolsEnabledForUrlParams(urlParams = null) {
	return isMediaToolsFeatureEnabled(urlParams);
}

export function isImageToolsEnabledForUrlParams(urlParams = null) {
	return isImageToolsFeatureEnabled(urlParams);
}
